module.exports = "pegasus/assets/themelp1/charity/106.png";